<template>
	<div>
		<!-- header container -->
		<Header/>
		<div class="bb-container">
			<div v-if="!dataFailure" class="uk-grid-collapse" uk-grid>
				<!-- builder preview -->
				<BuilderPreview />
				<!-- builder nav -->
				<Navigation />
				<!-- this component handles all the views that need to load -->
				<choose-size-view v-if="routeLocation === 'choose-size'" />
				<wood-finish-view v-if="routeLocation === 'wood-finish'" />
				<additions-view v-if="routeLocation === 'additions'" />
				<left-cabinet-view v-if="routeLocation === 'left_cabinet'" />
				<right-cabinet-view v-if="routeLocation === 'right_cabinet'" />
				<mattress-view v-if="routeLocation === 'mattress'" />
				<summary-view v-if="routeLocation === 'summary'" />
			</div>
			<div v-else>
				The Bed Builder feature is currently unavailable. Please contact us at (866) 343-4523 to review your options.
			</div>
		</div>
		<InfoModal />
	</div>
</template>

<script>

import Navigation from "./Layout/Navigation.vue";
import InfoModal from "./InfoModal.vue";
import Header from "./Layout/Header.vue";
import BuilderPreview from "./Layout/BuilderPreview.vue";

import ChooseSizeView from '../views/ChooseSize.vue';
import WoodFinishView from '../views/WoodFinish.vue';
import AdditionsView from '../views/Additions.vue';
import LeftCabinetView from '../views/LeftCabinet.vue';
import RightCabinetView from '../views/RightCabinet.vue';
import MattressView from '../views/Mattress.vue';
import SummaryView from '../views/Summary.vue';

import {EventBus} from "../main";

export default {
	name: "BedBuilder",

	props: {
    dataFailure:{
      type: Boolean,
      default: false
    }
  },
	components: {BuilderPreview, 
    Header, 
    InfoModal, 
    Navigation,
    ChooseSizeView,
    WoodFinishView,
    AdditionsView,
    LeftCabinetView,
    RightCabinetView,
    MattressView,
    SummaryView,
  },
	data() {
		return {
      routeLocation: "choose-size"
    }
	},
	mounted() {
    EventBus.$on('navigate', this.navigateTo);
	},
  beforeDestroy() {
    EventBus.$off('navigate', this.navigateTo);
  },
  methods: {
    navigateTo(route) {
      this.routeLocation = route;
    }
  },
	watch: {}
}
</script>